module.exports = __webpack_public_path__ + "assets/img/17_960.7a442767.jpg";